export default __webpack_public_path__ + "static/media/1.69dd80af.png";